module.exports = __webpack_public_path__ + "public/adminIcons/LoginPageVector.svg?cbea7578";


//////////////////
// WEBPACK FOOTER
// ./public/adminIcons/LoginPageVector.svg
// module id = 3326
// module chunks = 8